<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="width"
    :height="height"
    data-name="Layer 1"
    :viewBox="viewBox"
  >
    <path
      fill="#f2f2f2"
      d="M1120.51592,609.15349c-18.84034,38.87-51.46045,68.61-88.78028,91.24a392.45588,392.45588,0,0,1-47.64013,24.39q-16.10962,6.975-32.65967,12.73c-54.73,19.11-112.64014,28.45-170.65039,28.48q-14.22.015-28.43994-.73-4.0796-.21-8.15967-.48-21.49512-1.425-42.8501-4.57c-.28027-.04-.56982-.08-.8501-.13a539.77422,539.77422,0,0,1-87.77-20.57q-8.3247-2.7-16.5498-5.67c-1.48-.52-2.96-1.07-4.43018-1.61005q-9.27026-3.435-18.3999-7.21-7.68018-3.165-15.27-6.57-7.47-3.375-14.83984-6.97-12.06006-5.90991-23.86035-12.38995-9.10475-5.04008-17.96973-10.46a496.62043,496.62043,0,0,1-42.49024-29.08q-7.22973-5.52-14.25976-11.32c-3.25-2.68-6.47022-5.42-9.74024-8.07995-6.8999-5.61-14-10.94-21.91992-14.93a78.62631,78.62631,0,0,0-7.33984-3.24006,91.90524,91.90524,0,0,0-29.15039-5.67c-16.98975-.67-34.52979,2.49-50.96,7.17-7.80957,2.21-15.52979,4.75-23.25,7.35q-4.75488,1.605-9.5,3.22c-6.54,2.23-13.07959,4.41-19.67969,6.4-2.2002.66-4.3999,1.31-6.61035,1.92a194.22735,194.22735,0,0,1-26.90967,5.72,143.37367,143.37367,0,0,1-60.49023-5.27l-1.66993-.52c-2.7998-.88-5.56982-1.84-8.33007-2.88995l-1.66993-.64q-3.98949-1.545-7.83007-3.31l-1.66993-.76c-2.46-1.15-4.87011-2.35-7.23974-3.62-.2002-.1-.39014-.2-.59033-.31-.91993-.48-1.82959-1-2.73-1.49a164.61837,164.61837,0,0,1-39.15967-30.49c-.33008-.33-.64014-.67-1-1-1.59033-1.72-3.15039-3.47-4.66016-5.26-.56006-.66-1.12012-1.32-1.66992-2q-2.68506-3.285-5.18994-6.71c-.25-.33-.49024-.67-.73-1a145.03046,145.03046,0,0,1-16.87012-30.5c-.14014-.33-.27-.67-.39014-1q-1.9951-5.145-3.6499-10.47c-.45019-1.48-.87988-3-1.26025-4.48-.12989-.44-.25-.89-.35987-1.33-5.46972-21.72-6.06-44.31006-6.06-66.77v-7.85c.16015-36.33.72021-73.28,6.08007-109.11a6.03567,6.03567,0,0,1,.10987-.74,344.02421,344.02421,0,0,1,7.31006-35.82,265.59868,265.59868,0,0,1,12.31-36.3c12.33008-29,30.26026-55.39,50.16993-79.85,50.10009-61.51,115.87011-113.22,192.85009-132.51,82.9502-20.83,175.14014-.87,242.04981,52.4,19.73047,15.7,37.52051,34.2,59.39013,46.66q1.11036.645,2.25,1.26,4.33521,2.35491,8.85987,4.28a91.427,91.427,0,0,0,12.31006,4.25c13.29,3.57,27.18017,3.89,40.43017-.54,1.08008-.37,2.16016-.76,3.23-1.19,2.27-.9,4.43994-1.74,6.52979-2.52,14.26025-5.31,25.24023-7.89,42.57031-6.96a411.34574,411.34574,0,0,1,120.35986,25.19c1.56006.57,3.12012,1.16,4.66993,1.75,100.71,38.55005,187.30029,115.1,232.28027,213.47q1.79956,3.9,3.46973,7.86C1140.42558,474.62346,1150.10576,548.09349,1120.51592,609.15349Z"
      transform="translate(-61.33735 -57.98653)"
      style="isolation: isolate"
    />
    <polygon fill="#cacaca" points="63.608 512.617 63.608 513.017 63.458 513.197 63.608 512.617" />
    <path
      fill="#fff"
      d="M302.28545,630.83348q-4.75488,1.605-9.5,3.22v-3.22Z"
      transform="translate(-61.33735 -57.98653)"
    />
    <rect width="23.422" height="58.555" x="575.296" y="58.768" fill="#e4e4e4" />
    <path
      fill="#e4e4e4"
      d="M700.48564,170.69347v589.39a539.77422,539.77422,0,0,1-87.77-20.57q-8.3247-2.7-16.5498-5.67c-1.48-.52-2.96-1.07-4.43018-1.61005q-9.27026-3.435-18.3999-7.21-7.68018-3.165-15.27-6.57-7.47-3.375-14.83984-6.97-12.06006-5.90991-23.86035-12.38995-9.10475-5.04008-17.96973-10.46v-517.94Z"
      transform="translate(-61.33735 -57.98653)"
    />
    <path
      fill="#cacaca"
      d="M780.78545,170.69347v595.3q-14.22.015-28.43994-.73-4.0796-.21-8.15967-.48-21.49512-1.425-42.8501-4.57c-.28027-.04-.56982-.08-.8501-.13v-589.39Z"
      transform="translate(-61.33735 -57.98653)"
    />
    <rect width="30.114" height="30.114" x="476.029" y="171.26" fill="#fff" />
    <rect width="30.114" height="30.114" x="524.546" y="171.26" fill="#fff" />
    <rect width="30.114" height="30.114" x="573.063" y="171.26" fill="#fff" />
    <rect width="30.114" height="30.114" x="476.866" y="239.853" fill="#fff" />
    <rect width="30.114" height="30.114" x="525.382" y="239.853" fill="#fff" />
    <rect width="30.114" height="30.114" x="573.899" y="239.853" fill="#fff" />
    <rect width="30.114" height="30.114" x="477.702" y="308.445" fill="#fff" />
    <rect width="30.114" height="30.114" x="526.219" y="308.445" fill="#fff" />
    <rect width="30.114" height="30.114" x="574.736" y="308.445" fill="#fff" />
    <rect width="30.114" height="30.114" x="478.539" y="377.038" fill="#fff" />
    <rect width="30.114" height="30.114" x="527.055" y="377.038" fill="#fff" />
    <rect width="30.114" height="30.114" x="575.572" y="377.038" fill="#fff" />
    <rect width="30.114" height="30.114" x="479.375" y="445.631" fill="#fff" />
    <rect width="30.114" height="30.114" x="527.892" y="445.631" fill="#fff" />
    <rect width="30.114" height="30.114" x="576.409" y="445.631" fill="#fff" />
    <rect width="30.114" height="30.114" x="480.212" y="514.223" fill="#fff" />
    <rect width="30.114" height="30.114" x="528.728" y="514.223" fill="#fff" />
    <rect width="30.114" height="30.114" x="577.245" y="514.223" fill="#fff" />
    <rect width="30.114" height="30.114" x="481.048" y="582.816" fill="#fff" />
    <rect width="30.114" height="30.114" x="529.565" y="582.816" fill="#fff" />
    <rect width="30.114" height="30.114" x="578.082" y="582.816" fill="#fff" />
    <path
      fill="#fff"
      d="M573.33574,709.39348v15.63q-7.68018-3.165-15.27-6.57-7.47-3.375-14.83984-6.97v-2.09Z"
      transform="translate(-61.33735 -57.98653)"
    />
    <path
      fill="#fff"
      d="M621.85576,709.39348v30.12h-9.14014q-8.3247-2.7-16.5498-5.67c-1.48-.52-2.96-1.07-4.43018-1.61005v-22.84Z"
      transform="translate(-61.33735 -57.98653)"
    />
    <rect width="30.114" height="30.114" x="578.918" y="651.409" fill="#fff" />
    <rect width="23.422" height="34.704" x="848.27" y="356.962" fill="#e4e4e4" />
    <path
      fill="#e4e4e4"
      d="M951.43584,446.67345v290.84c-54.73,19.11-112.64014,28.45-170.65039,28.48q-14.22.015-28.43994-.73v-318.59Z"
      transform="translate(-61.33735 -57.98653)"
    />
    <path
      fill="#cacaca"
      d="M1031.73564,446.67345v253.72a392.45588,392.45588,0,0,1-47.64013,24.39q-16.10962,6.975-32.65967,12.73v-290.84Z"
      transform="translate(-61.33735 -57.98653)"
    />
    <rect width="30.114" height="30.114" x="730.324" y="445.631" fill="#fff" />
    <rect width="30.114" height="30.114" x="778.841" y="445.631" fill="#fff" />
    <rect width="30.114" height="30.114" x="827.357" y="445.631" fill="#fff" />
    <rect width="30.114" height="30.114" x="731.16" y="514.223" fill="#fff" />
    <rect width="30.114" height="30.114" x="779.677" y="514.223" fill="#fff" />
    <rect width="30.114" height="30.114" x="828.194" y="514.223" fill="#fff" />
    <rect width="30.114" height="30.114" x="731.997" y="582.816" fill="#fff" />
    <rect width="30.114" height="30.114" x="780.514" y="582.816" fill="#fff" />
    <rect width="30.114" height="30.114" x="829.03" y="582.816" fill="#fff" />
    <rect width="30.114" height="30.114" x="732.833" y="651.409" fill="#fff" />
    <rect width="30.114" height="30.114" x="781.35" y="651.409" fill="#fff" />
    <rect width="30.114" height="30.114" x="829.867" y="651.409" fill="#fff" />
    <path
      fill="#3f3d56"
      d="M775.91157,775.167s10.71245,38.099,55.57767,36.36726,64.26109-37.06,64.26109-37.06Z"
      transform="translate(-61.33735 -57.98653)"
    />
    <polygon
      fill="#2f2e41"
      points="96.331 568.594 83.513 592.07 85.594 636.133 392.751 727.401 526.504 743.85 500.355 584.338 408.852 568.136 271.586 572.058 155.211 550.584 96.331 568.594"
    />
    <path
      fill="#3f3d56"
      d="M200.42647,781.055h-7.92912A40.14406,40.14406,0,0,1,155.973,757.88037c-12.22389-26.68555-8.60289-63.58655-8.54928-64.11284,2.77-31.89509,20.25026-52.70411,43.50068-51.75976,25.66746,1.035,47.55461,89.81414,48.47377,93.59292a33.0874,33.0874,0,0,1-1.15288,19.199A40.01006,40.01006,0,0,1,200.42647,781.055Z"
      transform="translate(-61.33735 -57.98653)"
    />
    <path
      fill="#3f3d56"
      d="M523.76526,842.01347a27.92868,27.92868,0,0,1-4.04683-.391,62.70016,62.70016,0,0,1-47.34728-36.04322c-3.21495-6.99136-6.30779-14.14981-9.19261-21.27715-11.58462-28.62095-1.87316-78.65433,13.90662-98.02044,13.92725-17.09315,27.94481-16.95786,49.1653-16.75762,2.17859.021,4.43547.04194,6.77827.046,23.56092.03856,48.46938,86.70979,56.65455,115.19071.65145,2.26619,1.19026,4.14138,1.607,5.54777,1.28242,4.32808,1.13,9.50446-.45307,15.38438-4.99441,18.55095-21.45371,32.30908-40.957,34.23636C535.872,841.312,527.08557,842.01347,523.76526,842.01347Z"
      transform="translate(-61.33735 -57.98653)"
    />
    <path
      fill="#3f3d56"
      d="M146.93123,694.12s-9.00523-40.17716,4.50261-67.53919l13.6142-32.90371,51.446,47.797,11.74746,74.79042L429.55675,746.7659S417.088,624.1563,495.36417,619.30733s115.418,127.45857,115.418,127.45857L649.83842,775.167,922.0733,755.07842s4.80582,13.16148-2.0997,20.08857-337.328,28.4011-337.328,28.4011-16.625-164.17218-82.43244-148.93257S454.088,785.3877,454.088,785.3877L218.973,743.99506s-7.61981-111.52625-46.41155-111.52625S146.93123,694.12,146.93123,694.12Z"
      transform="translate(-61.33735 -57.98653)"
    />
    <polygon
      fill="#3f3d56"
      points="131.986 496.458 176.339 426.935 365.449 415.852 575.34 418.623 673.012 509.368 370.99 526.685 127.849 513.524 131.986 496.458"
    />
    <path
      :fill="color"
      d="M193.32368,554.44478s-37.73358.78691-41.88984,72.136c0,0,40.17716-72.73451,74.81264,89.35954L433.0203,749.53674S425.4005,614.45836,503.67668,624.849,600.656,759.23467,600.656,759.23467s15.23961,30.47923,99.05748,25.63026,209.19831-12.46877,222.35979-29.78651c0,0,30.47922-103.21374-64.422-169.71386L734.349,567.35411l-279.162,5.54167Z"
      transform="translate(-61.33735 -57.98653)"
    />
    <path
      fill="#cacaca"
      d="M287.89764,603.02865H264.34551a4.849,4.849,0,1,1,0-9.69793h23.55213a4.849,4.849,0,0,1,0,9.69793Z"
      transform="translate(-61.33735 -57.98653)"
    />
    <circle cx="585.038" cy="680.467" r="15.24" fill="#fff" />
    <path
      fill="#fff"
      d="M638.82474,663.67524c-10.43377,0-22.8902-4.4539-34.03985-13.04242-19.67407-15.1564-27.93974-37.53485-18.42546-49.88524,9.51427-12.35107,33.26122-10.068,52.93512,5.08709,9.50785,7.32486,16.66646,16.53032,20.15707,25.92046,3.51124,9.44629,2.89633,17.957-1.73177,23.9641C653.59758,661.07082,646.80206,663.67524,638.82474,663.67524Z"
      transform="translate(-61.33735 -57.98653)"
    />
    <path
      fill="#fff"
      d="M909.637,644.32538c-7.67629,0-21.46419-7.77269-35.11578-20.38623-8.18263-7.561-14.96158-15.66512-19.08808-22.82018-4.19143-7.268-5.14627-12.73531-2.6883-15.39521s7.98375-2.13968,15.55992,1.46457c7.45847,3.54879,16.07235,9.66682,24.25532,17.22777,17.2687,15.956,26.834,32.74271,21.77672,38.21606A6.13338,6.13338,0,0,1,909.637,644.32538Z"
      transform="translate(-61.33735 -57.98653)"
    />
    <path
      fill="#fff"
      d="M265.86284,554.4304q-.24708,0-.4967-.023l-50.0892-4.65718a5.38828,5.38828,0,0,1-4.08-8.2053l28.2455-45.53855a5.3846,5.3846,0,0,1,4.34127-2.54287l37.35914-1.64823a5.38824,5.38824,0,0,1,5.39928,6.92811L271.02687,550.587A5.40676,5.40676,0,0,1,265.86284,554.4304Z"
      transform="translate(-61.33735 -57.98653)"
    />
    <path
      fill="#fff"
      d="M397.85616,565.10009q-.741,0-1.49281-.073l-86.59429-8.5246a15.11775,15.11775,0,0,1-13.105-19.02042l12.45745-45.71a15.04774,15.04774,0,0,1,14.05865-11.13375l69.88537-2.44039a15.20219,15.20219,0,0,1,15.545,13.36781l5.76661,49.74724a15.08667,15.08667,0,0,1-.24844,4.97175l-1.51547,6.92743A15.12347,15.12347,0,0,1,397.85616,565.10009Z"
      transform="translate(-61.33735 -57.98653)"
    />
    <path
      fill="#fff"
      d="M465.43915,567.50564a11.26779,11.26779,0,0,1-10.93335-8.692l-15.27648-66.03031a11.22061,11.22061,0,0,1,10.93182-13.74968h181.153a11.28058,11.28058,0,0,1,8.05444,3.40841l59.16968,61.0058a11.22086,11.22086,0,0,1-7.8038,19.03024l-225.04641,5.02485C465.60505,567.505,465.52168,567.50564,465.43915,567.50564Z"
      transform="translate(-61.33735 -57.98653)"
    />
    <path
      :fill="color"
      d="M236.12986,487.34554l1.54633-2.42388s9.00522-24.93755,133.00025-29.0938,239.67753-2.07813,266.00049,20.78129l-214.04727-.69271L241.83244,488.38521Z"
      transform="translate(-61.33735 -57.98653)"
    />
    <path
      fill="#e4e4e4"
      d="M177.41045,665.02616c-13.00759,0-23.55213,21.70954-23.55213,48.48968,0,26.78009,10.54454,48.48967,23.55213,48.48967s23.55213-21.70958,23.55213-48.48967C200.96258,686.7357,190.418,665.02616,177.41045,665.02616Zm1.03906,10.39065c2.86927,0,5.19533,5.58243,5.19533,12.46877s-2.32606,12.46877-5.19533,12.46877-5.19532-5.58247-5.19532-12.46877S175.58025,675.41681,178.44951,675.41681Zm3.1172,38.099c0,2.29544-1.55082,4.15626-3.46355,4.15626s-3.46355-1.86082-3.46355-4.15626,1.55082-4.15626,3.46355-4.15626S181.56671,711.22039,181.56671,713.51584Zm-18.097,2.66755c-4.45425.34407-8.18094-.88145-8.32436-2.73727s3.35092-3.63922,7.80516-3.98329c4.45391-.34407,8.18061.88144,8.324,2.73731S167.92357,715.83932,163.46967,716.18339Zm14.97984,35.43148c-2.86926,0-5.19532-5.58248-5.19532-12.46878s2.32606-12.46877,5.19532-12.46877,5.19533,5.58244,5.19533,12.46877S181.31878,751.61487,178.44951,751.61487Zm13.42125-35.43148c-4.45424.34407-8.18094-.88145-8.32435-2.73727s3.35091-3.63922,7.80516-3.98329c4.45391-.34407,8.1806.88144,8.324,2.73731S196.32467,715.83932,191.87076,716.18339Z"
      transform="translate(-61.33735 -57.98653)"
    />
    <path
      fill="#e4e4e4"
      d="M506.44752,697.58352c-20.65884,0-37.40632,27.75721-37.40632,61.99751,0,34.24025,16.74748,61.99751,37.40632,61.99751s37.40632-27.75726,37.40632-61.99751C543.85384,725.34073,527.10637,697.58352,506.44752,697.58352Zm-22.34715,66.64992c-6.03314.466-11.0815-1.194-11.27565-3.7078s4.53915-4.92947,10.57228-5.39552,11.08149,1.194,11.27564,3.70776C494.867,761.3517,490.1335,763.76735,484.10037,764.23344Zm22.36914,47.30081c-3.88652,0-7.03719-7.56171-7.03719-16.88953s3.15067-16.88953,7.03719-16.88953c3.88668,0,7.03736,7.56171,7.03736,16.88953S510.35619,811.53425,506.46951,811.53425Zm-5.56366-51.60687c0-3.6727,2.48113-6.65,5.54167-6.65s5.54168,2.97733,5.54168,6.65-2.48114,6.65-5.54168,6.65S500.90585,763.60009,500.90585,759.92738Zm5.56366-17.82784c-3.88652,0-7.03719-7.56167-7.03719-16.88953s3.15067-16.88949,7.03719-16.88949c3.88668,0,7.03736,7.56167,7.03736,16.88949S510.35619,742.09954,506.46951,742.09954ZM530.19075,762.848c-6.03313.466-11.08149-1.194-11.27564-3.7078s4.53931-4.92947,10.57245-5.39552,11.08132,1.194,11.27547,3.70776S536.22389,762.38193,530.19075,762.848Z"
      transform="translate(-61.33735 -57.98653)"
    />
    <path
      fill="#cacaca"
      d="M375.5254,573.58849l8.31252,19.39587s13.85419,5.54168,22.85942-13.16148l-18.24772-18.24772Z"
      transform="translate(-61.33735 -57.98653)"
    />
    <path
      fill="#cacaca"
      d="M364.09569,578.09111c-14.89647,0-27.01567-8.07914-27.01567-18.01045,0-9.931,12.1192-18.01046,27.01567-18.01046s27.01568,8.07948,27.01568,18.01046C391.11137,570.012,378.99216,578.09111,364.09569,578.09111Z"
      transform="translate(-61.33735 -57.98653)"
    />
    <path
      fill="#3f3d56"
      d="M885.01631,641.474l-154.877,4.52735s-33.89425,9.50744-37.35285,36.67155c0,0,4.842,22.184,17.293,22.184s203.36548-9.96018,203.36548-9.96018,12.451-19.01488,2.07516-32.59693S885.01631,641.474,885.01631,641.474Z"
      transform="translate(-61.33735 -57.98653)"
    />
    <rect
      width="181.725"
      height="2.078"
      x="716.784"
      y="653.131"
      fill="#e4e4e4"
      transform="translate(-82.51257 -30.94157) rotate(-1.89362)"
    />
    <rect
      width="197.738"
      height="2.078"
      x="707.441"
      y="661.187"
      fill="#e4e4e4"
      transform="translate(-90.48339 -20.81434) rotate(-2.59409)"
    />
    <rect
      width="212.142"
      height="2.078"
      x="700.011"
      y="671.343"
      fill="#e4e4e4"
      transform="translate(-96.23224 -13.79524) rotate(-3.0738)"
    />
    <g id="fa69add6-ae6a-462f-9f4a-a8964149f7d7" data-name="Group 142">
      <path
        id="f4e602e9-d2b5-4192-9853-189e5cc927ef-97"
        fill="#ffb8b8"
        d="M176.30958,619.619a9.42193,9.42193,0,0,1,3.0431-14.123L177.385,584.05474l12.73787-4.37341,2.35384,30.31841a9.47291,9.47291,0,0,1-16.169,9.6202Z"
        data-name="Path 2185"
        transform="translate(-61.33735 -57.98653)"
      />
      <path
        id="e2d38235-adb3-41cf-b4a9-63352e01515a-98"
        fill="#e6e6e6"
        d="M189.98407,496.558s8.74117-18.34532,16.50892-11.89662-10.64934,60.69632-10.64934,60.69632l-2.80043,52.66236L178.281,596.54432l-4.17419-51.30272Z"
        data-name="Path 2186"
        transform="translate(-61.33735 -57.98653)"
      />
      <path
        id="eea0d059-1974-4b26-aac7-8a2396c42a8e-99"
        fill="#ffb8b8"
        d="M72.73188,767.96592,83.69,776.83644l39.42971-38.05026L106.94691,725.698Z"
        data-name="Path 2187"
        transform="translate(-61.33735 -57.98653)"
      />
      <path
        id="a9703c69-ade6-4e5d-bca9-6a3d314fecef-100"
        fill="#2f2e41"
        d="M72.83173,762.12528l21.581,17.46725h0a17.69478,17.69478,0,0,1,2.61914,24.88562l-.36161.44662L61.33735,776.32566Z"
        data-name="Path 2188"
        transform="translate(-61.33735 -57.98653)"
      />
      <path
        id="fb949616-149f-4f99-b6d4-35f2ecdeae65-101"
        fill="#ffb8b8"
        d="M225.02832,792.59h14.09843l6.70365-54.38451H225.02549Z"
        data-name="Path 2189"
        transform="translate(-61.33735 -57.98653)"
      />
      <path
        id="b920e865-38ed-4b06-94ca-a4364bcce1a4-102"
        fill="#2f2e41"
        d="M221.43078,787.98718h27.7663a17.69479,17.69479,0,0,1,17.69479,17.69292v.57593H221.4317Z"
        data-name="Path 2190"
        transform="translate(-61.33735 -57.98653)"
      />
      <path
        id="e64f2ddc-8714-4699-9f4e-cfc1a70d06b3-103"
        fill="#2f2e41"
        d="M249.76644,537.64662S276.21658,569.843,270.46656,602.047s-10.35006,56.35123-10.35006,56.35123l-9.19534,72.44847s3.45,19.73328-1.15,24.81578c0,0,6.9,11.98441-5.75,16.58444s-19.48024-1.58626-19.48024-1.58626-9.27463-13.361-3.52461-16.80632l2.42276-142.19279L131.3168,731.99667s-1.6929,14.63472-13.497,14.79337l-14.10316,10.50677-16.10007-9.202,8.05-10.35s-4.6-11.5,5.75-13.80009L161.217,645.74621,176.167,605.496s8.05-31.05014,29.90014-43.70021V548.3366Z"
        data-name="Path 2191"
        transform="translate(-61.33735 -57.98653)"
      />
      <path
        id="bce97f6a-e88b-4fe5-bf4a-3ce22a01c084-104"
        fill="#e6e6e6"
        d="M204.34215,481.87135h0a21.95964,21.95964,0,0,1,28.94465-4.0864l.9555.63731h0a84.76523,84.76523,0,0,1,19.84278,40.85541l4.30639,23.54492L204.3412,554.53036l-12.67085-43.70022a24.68926,24.68926,0,0,1,12.67085-28.95787Z"
        data-name="Path 2192"
        transform="translate(-61.33735 -57.98653)"
      />
      <path
        id="b697c87b-19ec-4b06-9e7e-37987317631c-105"
        fill="#ffb8b8"
        d="M293.14279,624.625a10.78347,10.78347,0,0,1-6.15132-15.34853L271.39935,590.1947l9.285-12.30355,21.64051,27.25739a10.842,10.842,0,0,1-9.18211,19.47647Z"
        data-name="Path 2193"
        transform="translate(-61.33735 -57.98653)"
      />
      <path
        id="ff802918-ea99-4deb-b868-19882644d1b6-106"
        fill="#e6e6e6"
        d="M227.34133,499.12145s-3.45-23.00013,8.05-21.8501,28.75015,64.40032,28.75015,64.40032l31.05014,51.75025-14.95006,8.05-36.80019-46.00022Z"
        data-name="Path 2194"
        transform="translate(-61.33735 -57.98653)"
      />
      <path
        id="b2ad01c3-7822-402f-83d4-81805929538c-107"
        fill="#2f2e41"
        d="M248.40115,465.49653H193.639a4.25351,4.25351,0,0,1-4.24879-4.24879V437.64335a31.62987,31.62987,0,1,1,63.25975,0h0v23.60439A4.25351,4.25351,0,0,1,248.40115,465.49653Z"
        data-name="Path 2195"
        transform="translate(-61.33735 -57.98653)"
      />
      <circle
        id="fe1c8106-5903-484b-8252-f0483d4636a1"
        cx="166.183"
        cy="383.771"
        r="23.19"
        fill="#ffb8b8"
        data-name="Ellipse 430"
      />
      <path
        id="e2d5a9f4-7ffc-4596-9574-3d578968164c-108"
        fill="#2f2e41"
        d="M260.13255,440.00379H230.94808l-.29929-4.80775-1.49651,4.80775H224.659l-.59293-9.52863-2.96565,9.52863h-8.69493v-.47209c0-13.79629,9.7826-25.02065,21.81046-25.02065h4.11472c12.02406,0,21.81046,11.22436,21.81046,25.02065Z"
        data-name="Path 2196"
        transform="translate(-61.33735 -57.98653)"
      />
      <path
        id="aa8282a4-b0b8-48ea-8496-97297549be2f-109"
        fill="#2f2e41"
        d="M232.15663,469.903a7.01819,7.01819,0,0,1-1.065-.08215l-34.73715-5.35064V428.28939a13.936,13.936,0,0,1,13.936-13.936h24.3031l-.94418.964c-13.17126,13.40731-3.248,35.15449,3.839,46.92553a4.6378,4.6378,0,0,1-.47209,5.49606,6.30989,6.30989,0,0,1-4.85777,2.1669Z"
        data-name="Path 2197"
        transform="translate(-61.33735 -57.98653)"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import SvgMixin from "@/mixins/SvgMixin.vue";
import { Component } from "vue-property-decorator";

@Component({
  components: {}
})
export default class ThgDescriptionSvgCar extends SvgMixin {}
</script>
